module.exports = __webpack_public_path__ + "img/4405d4d.png";